import React, {useEffect, useState} from "react";
import {Subscription, SubscriptionPlan} from "../../models/subscription";
import {Box, Button, Card, Chip, Stack, Typography, useTheme} from "@mui/joy";
import {CheckIcon, UserIcon} from "lucide-react";
import {useUITheme} from "../../hooks/useUITheme";
import axios from "axios";
import {COUNTRY_CURRENCIES} from "../../utils/currency";
import {useTranslation} from "react-i18next";
import {useLanguage} from "../../hooks/useLanguage";
import {Link} from "react-router-dom";

type SubscriptionComponentProps = {
    subscription: SubscriptionPlan,
    isCurrentPlan?: boolean
    onSelect?: () => void
}

const PricingCardComponent = (props: SubscriptionComponentProps) => {
    const theme = useTheme()
    const {t} = useTranslation()
    const language = useLanguage()

    return <Card data-no-glow={!props.subscription.isPopular}
                 sx={{paddingY: 4, justifyContent: "space-between", minHeight: "20rem"}}>

        {props.subscription?.isPopular &&
            <Chip data-accent
                  sx={{
                      position: "absolute", zIndex: 4, top: -12, alignSelf: "center",
                      color: "white",
                      bgcolor: "primary.500"
                  }}
                  size={"lg"}>
                {t("popularPlanLabel")}
            </Chip>}

        <Typography level={"title-lg"}>
            {props.subscription.isTrial ? t("subscriptionFreeTrialLabel") : props.subscription.name}
        </Typography>

        {!props.subscription.isTrial && <Stack direction="row" alignItems="baseline" gap={0.5} sx={{my: 1}}>
            <Typography level="h2" sx={{fontSize: "2rem"}}>
                {props.subscription.localizedPrice}
            </Typography>
            {!props.subscription.isLifetime && props.subscription.frequencyLabel && (
                <Typography level="body-sm" textColor="neutral.500">
                    /{props.subscription.frequencyLabel}
                </Typography>
            )}
        </Stack>}

        <Stack>
            {props.subscription.features.map(feature =>
                <Typography textTransform={"capitalize"}
                            startDecorator={<CheckIcon style={{fontSize: 18, color: theme.palette.success['500']}}/>}>
                    {feature[language.lang]}
                </Typography>)}
        </Stack>

        {props.isCurrentPlan ?
            <Button variant={"outlined"} disabled>
                {t("currentSubscriptionPlanLabel")}
            </Button> :
            <Button component={Link} to={`/checkout?subscriptionId=${props.subscription._id}`} size={"lg"}
                    fullWidth
                    sx={{marginTop: 2}}
                    onClick={props.onSelect}>
                {t("registerActionLabel")}
            </Button>}

    </Card>

}

export default PricingCardComponent